var exports = {
  "Y": "x234b8571--c32b1a--tooltip",
  "Q": "x234b8571--c32b1a--content",
};

module.exports = exports;
